import { createRouter, createWebHistory } from 'vue-router';
import CalendarView from '../views/CalendarView.vue';
import SettingsView from '../views/SettingsView.vue';

const routes = [
  { path: '/', name: 'calendar', component: CalendarView },
  { path: '/settings', name: 'settings', component: SettingsView },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
